export enum SessionType {
  Batting = 'Batting',
  InGame = 'In-Game',
  Practice = 'Practice',
  Rehab = 'Rehab',
  Tracking = 'Tracking',
}

export enum ITotalBpChartUnit {
  Day = 'day',
  Month = 'month',
}

export enum DetectionIssueType {
  Speed = 'Speed',
  VerticalBreak = 'VerticalBreak',
  HorizontalBreak = 'HorizontalBreak',
  HitResult = 'HitResult',
  HitMetrics = 'HitMetrics',
  PlateLocation = 'PlateLocation',
  VideoQuality = 'VideoQuality',
}
